/* istanbul ignore file */
import { useState } from 'react';
import { MARK_AS_PAID_EXPENSE, useExpenseService } from 'domain/shared/expense';
import { getVisibility } from 'framework/utils';
import { useShowContext } from 'framework/show';
import { FormFieldsData, TextArea } from 'framework/form';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';

export type RejectExpenseButtonProps = {
  isVisible: boolean | ((data: any) => boolean);
  ids: string[];
  onSubmit?: () => void;
};

const RejectExpenseButton = ({ ids, isVisible, onSubmit }: RejectExpenseButtonProps) => {
  const { rejectExpense, invalidateCache } = useExpenseService();
  const { data, setData = () => {} } = useShowContext();

  const [rejectReason, setRejectReason] = useState('');
  const [rejectReasonErrors, setRejectReasonErrors] = useState<string[]>([]);

  if (!getVisibility(data, isVisible as any)) {
    return null;
  }

  const onReasonChange = (values: FormFieldsData) => {
    setRejectReason(values.rejectReason);
    setRejectReasonErrors(values.rejectReason ? [] : ['Field is required']);
  };

  const execute = (newExpenseData?: any, shouldUpdateData?: boolean) => {
    invalidateCache();
    if (onSubmit) {
      onSubmit();
    } else if (shouldUpdateData && newExpenseData[0]) {
      setData(newExpenseData[0]);
    }
  };

  return (
    <ButtonWithConfirmation
      displayMessage={`Do you really want to reject ${
        ids.length > 1 ? `these expenses (ids: ${ids.join(', ')})` : `this expense (id: ${ids[0]})`
      }? Please fill out the reason below.`}
      modalChildren={
        <>
          <TextArea
            source="rejectReason"
            value={rejectReason}
            label="Please, enter the reject reason"
            onChangeCallback={onReasonChange}
            errorMessages={rejectReasonErrors}
            sx={{ mt: 2.5 }}
          />
        </>
      }
      submitMethod={() => rejectExpense(ids, rejectReason)}
      afterSubmit={{
        successMessage: `The Expense${ids.length > 1 ? 's have' : ' has'} been successfully rejected.`,
        errorMessage: `Can't reject expense${ids.length > 1 ? 's' : ''}.`,
        execute: (newExpenseData: any) => execute(newExpenseData, true),
        executeOnError: execute,
      }}
      permissionToCheck={MARK_AS_PAID_EXPENSE}
      variant="outlined"
      confirmBtnProps={{ disabled: !rejectReason }}
      closeOnSubmit={false}
      color="error"
    >
      Reject
    </ButtonWithConfirmation>
  );
};

export default RejectExpenseButton;
